export default "__VITE_ASSET__D8Oisznn__"